import classNames from 'classnames';
import { useRef, useEffect, useState } from 'react';

import "../../styles/in-view.css";

function useIsInViewport(ref) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsIntersecting(entry.isIntersecting),
      { threshold: 0.1 } // Adjust threshold as needed (e.g., 0.1 means 10% visible)
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref]); // Re-run effect if ref changes

  return isIntersecting;
}

function InViewPort({children}) {
  
  const elementRef = useRef(null);
  const isInViewport = useIsInViewport(elementRef);

  return (
    <div ref={elementRef} className='view-anim'>
      <div className={classNames({'opacity-anim': !isInViewport},{'in-view': isInViewport})}>
         {children}
      </div>
    </div>
  );
}

export default InViewPort;